import styled from "styled-components";

export const TextEditorWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid #95959d;
  background-color: white;
  color: #000000;
  width: 100%;
`;

export const SectionLabel = styled.label`
  text-align: left;
  color: rgb(64, 86, 244);
  font-family: Rubik;
  font-size: 1.1rem;
  margin: ${({ bottom }) => (bottom ? "0 0 1rem" : "1rem 0 0.625rem")};
`;

export const SectionHeader = styled.h2`
  text-align: left;
  font-size: 1rem;
  margin: 1rem 0 0.625rem;
  color: rgb(64, 86, 244);
`;
